import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { convertToLocalDate, DateOnly, PatientEventLogsFilter } from '../../core';
import { BaseComponent, DatepickerComponent } from '../../shared';


/**
 * Component for events filters in patient history page.
 */
@Component({
	selector: 'tsp-history-filters',
	imports: [
		FormsModule,
		DatepickerComponent
	],
	templateUrl: './history-filters.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class HistoryFiltersComponent extends BaseComponent {

	filters = model.required<PatientEventLogsFilter | undefined>();
	isDiary = input.required<boolean>();
	isReadonly = input<boolean>();

	isReadCheckboxVisible = computed(() => !this.isDiary() && !this.isReadonly());

	get fromDateFormat(): string | null {
		return this.filters()!.dateFrom ? convertToLocalDate(this.filters()!.dateFrom!) : null;
	}
	get toDateFormat(): string | null {
		return this.filters()!.dateTo ? convertToLocalDate(this.filters()!.dateTo!) : null;
	}

	/**
	 * Clear Date From.
	 */
	clearFromDate(): void {
		this.filters()!.dateFrom = null;
	}

	/**
	 * Clear Date To.
	 */
	clearToDate(): void {
		this.filters()!.dateTo = null;
	}

	/**
	 * Update Date From.
	 */
	updateFromDate(date: Date | null): void {
		this.filters()!.dateFrom = date ? new DateOnly(date) : null;
	}

	/**
	 * Update Date To.
	 */
	updateToDate(date: Date | null): void {
		this.filters()!.dateTo = date ? new DateOnly(date) : null;
	}

	/**
	 * Clear filters.
	 */
	clear(): void {
		this.filters.set(undefined);
	}

	/**
	 * Search according to filters.
	 */
	search(): void {
		this.filters.set({ ...this.filters()! });
	}

}
